<style lang="scss">
  #leaderboardRanking {
    align-items: center;
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 1.5rem;
    margin-top: 0.5rem;
  }
</style>

<script>
  import { formatDatum, sortData } from "../utils/utils";
  import LeaderboardRankingItem from "./LeaderboardRankingItem.svelte";

  export let data;
  export let selectedLeaderboardOption;
  export let dataType;

  $: rankedUsers = sortData(data, selectedLeaderboardOption).slice(0, 3);
</script>

<div id="leaderboardRanking">
  {#if rankedUsers.length >= 2}
    <LeaderboardRankingItem
      size="md"
      rank="2"
      name={rankedUsers[1].name}
      value={formatDatum(rankedUsers[1][selectedLeaderboardOption], dataType)}
      image={rankedUsers[1].image}
    />
  {/if}

  {#if rankedUsers.length >= 1}
    <LeaderboardRankingItem
      size="lg"
      rank="1"
      name={rankedUsers[0].name}
      value={formatDatum(rankedUsers[0][selectedLeaderboardOption], dataType)}
      image={rankedUsers[0].image}
    />
  {/if}

  {#if rankedUsers.length >= 3}
    <LeaderboardRankingItem
      size="md"
      rank="3"
      name={rankedUsers[2].name}
      value={formatDatum(rankedUsers[2][selectedLeaderboardOption], dataType)}
      image={rankedUsers[2].image}
    />
  {/if}
</div>
